import { env } from '@shared/config/env';

// Static Maps renders to a flat PNG with no CSS access, so the marker color can't come from the
// `--color-primary` custom property at request time — it's read here from the generated token
// file (apps/web/src/shared/ui/tokens/theme.css light value) instead of an invented hex, per the
// "no colors authored in code" convention.
const MARKER_COLOR_HEX = '354c8f';

/**
 * Google Static Maps image URL. With the browser key configured it points straight at Google
 * (an `<img>` fetch — no CORS involved), which is the only form that works on a deployed build;
 * without it, the URL routes through the /maps-api Vite dev proxy (which injects the key
 * server-side). `size` is `${width}x${height}` CSS pixels (Static Maps expects device px,
 * so this doubles for `scale=2` to stay sharp on HiDPI screens).
 */
export function staticMapUrl(
  lat: number,
  long: number,
  {
    width,
    height,
    zoom = 17,
    // `marker: false` renders the map WITHOUT the embedded center marker — for the draggable
    // panel, which overlays its own FIXED pin (the image pans underneath it, mobile-style).
    marker = true,
  }: { width: number; height: number; zoom?: number; marker?: boolean },
): string {
  const key = env.VITE_GOOGLE_MAPS_API_KEY;
  const params = new URLSearchParams({
    center: `${lat},${long}`,
    zoom: String(zoom),
    size: `${width}x${height}`,
    scale: '2',
    ...(marker ? { markers: `color:0x${MARKER_COLOR_HEX}|${lat},${long}` } : {}),
    ...(key ? { key } : {}),
  });
  const base = key
    ? 'https://maps.googleapis.com/maps/api/staticmap'
    : '/maps-api/maps/api/staticmap';
  return `${base}?${params.toString()}`;
}
